import { render, staticRenderFns } from "./AdvisorMain.vue?vue&type=template&id=48e7acf6&scoped=true&"
import script from "./AdvisorMain.vue?vue&type=script&lang=js&"
export * from "./AdvisorMain.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorMain.vue?vue&type=style&index=0&id=48e7acf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e7acf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VAppBar,VAvatar,VIcon,VSpacer,VSubheader})
